import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { APDTable } from "@/features/apd/APDTable";

export function APDIndex() {
  return (
    <>
      <Breadcrumbs />
      <H2>APD List</H2>
      <APDTable />
    </>
  );
}
